/**
 * Created Date: 2019-09-06
 * Author: Grays
 * -----
 * Last Modified: 2020-10-20 9:54:15
 * Modified By: Grays
 * 
 */


import Vue from 'vue'
/**
 *生成返回信息
 *
 * @param {*} code
 * @param {*} msg
 * @param {*} data
 * @returns
 */
const create_result =(code, msg, data) => {
    
    return{
        code:code,
        msg:msg,
        data:data
    }
}

/**
 *post 数据到服务器
 *
 * @param {*} url
 * @param {*} data
 * @returns 
 */

const post  = (url, data={})=>{
    
    return new Promise<any>((resolve, reject) => {
        Vue.$axios({
            url: url,
            method: 'post',
            data:data
        }).then((d) =>{
            if (d.data.code==0){
                resolve(d.data)
            }else{
              reject(d.data)
            }
        }).catch((d)=>{
          reject(create_result(-1,"服务器错误",d));
        })
    })
}
/**
 *get 数据
 *
 * @param {*} url
 * @param {*} data
 * @returns
 */
const get  = (url, data={})=>{
    return new Promise<any>((resolve, reject) => {
        Vue.$axios({
            url: url,
            method: 'get',
            data:data
        }).then((d) =>{
            if (d.data.code==0){
                resolve(d.data)
            }else{
              reject(d.data)
            }
        }).catch((d)=>{
          reject(create_result(-1,"服务器错误",d));
        })
    })
}

export const request={
    get:get,
    post:post
}

